import { CancelRounded, CheckCircle } from "@mui/icons-material";
import { LinearProgress } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import IzinMajuSidangService from "../../../../../services/Integration/izin-maju-sidang/IzinMajuSidangService";

export default function MKSpesialStatusIzinMajuSidang({ mKSpesial }) {
  const [isLoading, setIsLoading] = useState(false);
  const [statusIzinMaju, setStatusIzinMaju] = useState([]);

  useEffect(() => getStatusIzinMajuDosen(), []);

  const getStatusIzinMajuDosen = async () => {
    setIsLoading(true);
    await IzinMajuSidangService.getIzinMajuSidangPembimbing(mKSpesial.id)
      .then((response) => {
        if (response.status === 200) {
          setStatusIzinMaju(response.data.persetujuan);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
    setIsLoading(false);
  };

  return (
    <div className="mt-4 text-sm">
      {isLoading ? (
        <LinearProgress />
      ) : (
        <table id="prasidang-table">
          <tbody className="align-top">
            <tr>
              <td className="text-center font-bold" colSpan={2}>
                {`${mKSpesial.jenis_sidang}: ${mKSpesial.judul}`}
              </td>
            </tr>
            <tr>
              <td width={175}>
                <b>Dosen Pembimbing:</b>
              </td>
              <td>
                <ul className="list-disc list-inside">
                  {statusIzinMaju.map((persetujuan, index) => (
                    <li key={index}>
                      {persetujuan.dosen.nama_lengkap}
                      {", "}
                      <b>Status:</b>{" "}
                      {persetujuan.is_approved ? (
                        <>
                          <CheckCircle htmlColor="green" />{" "}
                          <span>telah menyetujui untuk maju sidang</span>
                        </>
                      ) : (
                        <>
                          <CancelRounded htmlColor="#EC1D1D" />{" "}
                          <span>belum menyetujui untuk maju sidang</span>
                        </>
                      )}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
